"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecated = exports.withRequestHeaders = exports.appendDescription = exports.transformOperation = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Api.OpenApi.Annotations';
/**
 * Registers a transformation of the generated OpenAPI operation.
 *
 * `OpenApi.Transform` is a plain annotation: annotating twice replaces the
 * first function. This helper composes with whatever transform the endpoint
 * already carries so several helpers (redirect headers, role lists, ...) can
 * be stacked on the same endpoint.
 */
const transformOperation = (f) => (endpoint) => {
    const previous = effect_1.Context.getOption(endpoint.annotations, platform_1.OpenApi.Transform);
    const transform = effect_1.Option.match(previous, {
        onNone: () => f,
        onSome: g => (operation) => f(g(operation)),
    });
    return endpoint.annotate(platform_1.OpenApi.Transform, transform);
};
exports.transformOperation = transformOperation;
/** Appends a paragraph to the operation description (creating it when absent). */
const appendDescription = (paragraph) => (0, exports.transformOperation)(operation => {
    const current = operation['description'];
    const description = typeof current === 'string' && current.length > 0 ? `${current}\n\n${paragraph}` : paragraph;
    return { ...operation, description };
});
exports.appendDescription = appendDescription;
/**
 * Documents request headers that the endpoint schema does not carry.
 *
 * Meant for headers a guard reads but no handler decodes (e.g. signature
 * material). Headers that are part of the contract belong in
 * `HttpApiEndpoint.setHeaders`; this only touches the generated operation.
 */
const withRequestHeaders = (headers) => (0, exports.transformOperation)(operation => {
    const existing = Array.isArray(operation['parameters']) ? operation['parameters'] : [];
    const added = Object.entries(headers).map(([name, header]) => ({
        name,
        in: 'header',
        description: header.description,
        required: header.required ?? true,
        schema: header.schema ?? { type: 'string' },
    }));
    return { ...operation, parameters: [...existing, ...added] };
});
exports.withRequestHeaders = withRequestHeaders;
/** Marks an operation as deprecated, optionally documenting the replacement. */
const deprecated = (replacement) => (endpoint) => {
    const marked = endpoint.annotate(platform_1.OpenApi.Deprecated, true);
    return replacement === undefined
        ? marked
        : (0, exports.appendDescription)(`Deprecated. Use ${replacement} instead.`)(marked);
};
exports.deprecated = deprecated;
//# sourceMappingURL=annotations.js.map